var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "27px",
    viewBox: "0 0 24 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notifications") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-1582.000000, -17.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1582.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7999897,19.6363828 L21.5999794,19.6363828 L21.5999794,9.81819141 C21.5999794,4.40469141 17.2931835,0 12,0 C6.70681654,0 2.40002062,4.40469141 2.40002062,9.81819141 L2.40002062,19.6363828 L1.20001031,19.6363828 C0.536403011,19.6363828 0,20.1849785 0,20.8636699 C0,21.5423613 0.536403011,22.090957 1.20001031,22.090957 L2.40002062,22.090957 L7.20001031,22.090957 C7.20001031,24.7982871 9.35278952,27 12,27 C14.6472105,27 16.7999897,24.7982871 16.7999897,22.0909043 L21.5999794,22.0909043 L22.7999897,22.0909043 C23.463597,22.0909043 24,21.5423086 24,20.8636172 C24,20.1849258 23.4635454,19.6363828 22.7999897,19.6363828 Z M11.9999758,24.6857143 C10.7590933,24.6857143 9.75,23.6477289 9.75,22.3714286 L14.25,22.3714286 C14.2499517,23.6477289 13.2408584,24.6857143 11.9999758,24.6857143 Z M19.5,19.2857143 L17.125017,19.2857143 L7.62498299,19.2857143 L5.25,19.2857143 L5.25,9.58774022 C5.25,5.57644329 8.44557546,2.31428571 12.375,2.31428571 C16.3044245,2.31428571 19.5,5.57644329 19.5,9.58774022 L19.5,19.2857143 L19.5,19.2857143 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBell);
export default __webpack_public_path__ + "static/media/notifications-bell.ff20f40c.svg";
export { ForwardRef as ReactComponent };